import { render, staticRenderFns } from "./ExtraInfoDetails.component.vue?vue&type=template&id=a5477d98&"
import script from "./ExtraInfoDetails.component.vue?vue&type=script&lang=ts&"
export * from "./ExtraInfoDetails.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports